import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as actions from '../../actions/OrderActions'
class Order extends Component {

    componentDidMount() {
        this.props.getAllOrder();
    }

    convert = (str) => {
        var date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return [day, mnth, date.getFullYear()].join("-");
    }

    format_curency = ((money) => {
        money = money.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return money + "₫";
    });

    showAllOrder = (orders) => {
        if (orders) {
            return orders.map((item, index) => {
                var date = item.date;
                var dateTime = this.convert(new Date(date).toString())
                return (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td style={{ width: '150px' }}>{item.nameUser}</td>
                        <td style={{ width: '100px' }}>{item.addressUser}</td>
                        <td style={{ width: '100px' }}>{item.phoneUser}</td>
                        <td style={{ width: '120px' }}>{this.format_curency(item.totalPrice)}</td>
                        <td style={{ width: '100px' }}>{dateTime}</td>
                        <td style={{ width: '150px' }}>{item.note}</td>
                        <td>
                            {item.status}
                        </td>
                        <td>
                            <Link
                                to={`/orders/${item.id}`}
                                className="btn btn-outline-info mr-3"

                            >
                                View detail</Link>
                            <button
                                onClick={() => {
                                    this.props.changeStatusOrder({
                                        id: item.id,
                                        nameUser: item.nameUser,
                                        addressUser: item.addressUser,
                                        phoneUser: item.phoneUser,
                                        totalPrice: item.totalPrice,
                                        date: item.date,
                                        note: item.note,
                                        status: 'Đã chốt',
                                        listOrder: item.listOrder
                                    })
                                }}
                                className="btn btn-outline-success">Chốt đơn</button>
                        </td>
                    </tr>
                )
            })
        }
    }

    render() {
        var { orders } = this.props;
        return (
            <div className="products__page pt-2 pb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h3 className="account__page--title">Orders</h3>
                        </div>
                        <div className="col-12">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>STT</th>
                                        <th>User Name</th>
                                        <th>User Address</th>
                                        <th>User Phone</th>
                                        <th>Total</th>
                                        <th>Date</th>
                                        <th>Note</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.showAllOrder(orders)}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        orders: state.orders.listOrder
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getAllOrder: () => {
            dispatch(actions.fetchAPIAllOrder())
        },
        changeStatusOrder: (order) => {
            dispatch(actions.fetchAPIChangeStatusOrder(order))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Order);
